export enum ISO6391 {
  AF = 'af', // Afrikaans
  SQ = 'sq', // Albanian
  AR = 'ar', // Arabic
  HY = 'hy', // Armenian
  AZ = 'az', // Azerbaijani
  EU = 'eu', // Basque
  BN = 'bn', // Bengali
  BG = 'bg', // Bulgarian
  CA = 'ca', // Catalan
  ZH_HANS = 'zh-Hans', // Chino simplificado
  ZH_HANT = 'zh-Hant', // Chino tradicional
  HR = 'hr', // Croatian
  CS = 'cs', // Czech
  DA = 'da', // Danish
  NL = 'nl', // Dutch
  EN = 'en', // English
  EO = 'eo', // Esperanto
  ET = 'et', // Estonian
  FI = 'fi', // Finnish
  FR = 'fr', // French
  GL = 'gl', // Galician
  KA = 'ka', // Georgian
  DE = 'de', // German
  EL = 'el', // Greek
  GU = 'gu', // Gujarati
  HE = 'he', // Hebrew
  HI = 'hi', // Hindi
  HU = 'hu', // Hungarian
  IS = 'is', // Icelandic
  ID = 'id', // Indonesian
  IT = 'it', // Italian
  JA = 'ja', // Japanese
  KN = 'kn', // Kannada
  KK = 'kk', // Kazakh
  KO = 'ko', // Korean
  LV = 'lv', // Latvian
  LT = 'lt', // Lithuanian
  MK = 'mk', // Macedonian
  MS = 'ms', // Malay
  ML = 'ml', // Malayalam
  MT = 'mt', // Maltese
  MN = 'mn', // Mongolian
  NO = 'no', // Norwegian
  FA = 'fa', // Persian
  PL = 'pl', // Polish
  PT = 'pt', // Portuguese
  PA = 'pa', // Punjabi
  RO = 'ro', // Romanian
  RU = 'ru', // Russian
  SR = 'sr', // Serbian
  SK = 'sk', // Slovak
  SL = 'sl', // Slovenian
  ES = 'es', // Spanish
  SW = 'sw', // Swahili
  SV = 'sv', // Swedish
  TA = 'ta', // Tamil
  TE = 'te', // Telugu
  TH = 'th', // Thai
  TR = 'tr', // Turkish
  UK = 'uk', // Ukrainian
  UR = 'ur', // Urdu
  VI = 'vi', // Vietnamese
  CY = 'cy', // Welsh
}
